// removed by extract-text-webpack-plugin
module.exports = {"container":"s93RF","enter":"_1bYzr","appear":"_1XYQj","enterActive":"voVCx","appearActive":"_3mamL"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-page-stats/post-page-stats.scss
// module id = 1692
// module chunks = 0